var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, } from "../../../recoil/menuState";
import { getApiLangState } from "../../../recoil/langState";
// img, css etc
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
// components
import EhpImageCrop from "../../common/imagecrop/EhpImageCrop";
import AutoComplete from "../../common/autocomplete/AutoComplete";
/**
 * @brief EHP 사업장 전기실 관리 - 회사/사업장 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function ZoneInsertAdmin(props) {
    //recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const setParentCurTree = props.setCurTree;
    //
    //첨부 이미지 처리 ref
    const fileRef = useRef();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    /// company list
    const [companyList, setCompanyList] = useState([]);
    const { data: retList, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/companies`,
        appQuery: {},
        language: apiLang,
        userToken: userInfo.loginInfo.token,
        watch: ""
    });
    useEffect(() => {
        if (retList) {
            if (retList.codeNum == CONST.API_200) {
                clog("IN COMPANY LIST : RES : " + JSON.stringify(retList.data.page));
                setCompanyList(retList.body.map((comp) => (Object.assign(Object.assign({}, comp), { "autofield": comp.companyName }))));
            }
            else {
                setErrorList(retList.data.errorList);
            }
        }
    }, [retList]);
    const [autoCompanyInfo, setAutoCompanyInfo] = useState(null);
    function resetAutoCompanyInfo() {
        setAutoCompanyInfo(null);
        resetCompanyInfo();
    }
    const [companyInfo, setCompanyInfo] = useState({
        "companyId": "",
        "companyName": "",
        "url": "",
        "businessNo": "",
        "administrator": "",
        "classification": "",
        "accountManager": "",
        "accMngrTelephone": "",
        "interfaceInfo": "",
        "memo": ""
    });
    const resetCompanyInfo = () => (setCompanyInfo({
        "companyId": "",
        "companyName": "",
        "url": "",
        "businessNo": "",
        "administrator": "",
        "classification": "",
        "accountManager": "",
        "accMngrTelephone": "",
        "interfaceInfo": "",
        "memo": ""
    }));
    const [zoneInfo, setZoneInfo] = useState({
        "zoneName": "",
        "address": "",
        "memo": ""
    });
    // comment 길이 제한 콜백 함수
    function callbackSetZoneInfoMemo(callbackmemo) {
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: callbackmemo }));
    }
    const [errorList, setErrorList] = useState([]);
    // called by AutoComplete
    function handleSetAutoComplete(autoInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            if (CUTIL.isnull(autoInfo))
                return;
            setAutoCompanyInfo(autoInfo);
            setRecoilIsLoadingBox(true);
            const data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/product/company/${autoInfo.companyId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: autoInfo.companyId
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("COMP INFO : " + JSON.stringify(data.body));
                    setErrorList([]);
                    setCompanyInfo(data.body);
                }
                else { // api if need error handle
                    setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    function onClickCompZoneAdminInsert(e) {
        setParentWorkMode("ADMIN_COMP_CREATE");
    }
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [cropedImage, setCropedImage] = useState(null);
    useEffect(() => {
        setParentPopWin("pop-imgcrop", React.createElement(EhpImageCrop, { cropImage: selectedFiles, setCropedImage: handleSetCropedImage }));
    }, [selectedFiles]); // selected files이 변경될때마다...이미지 반영을 위해
    useEffect(() => {
        setParentPopWin("pop-area-rigth", React.createElement(MobileZoneInsertAdmin, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"), zoneInfo: zoneInfo, setZoneInfo: setZoneInfo, callbackSetZoneInfoMemo: callbackSetZoneInfoMemo, errorList: errorList, 
            //autocomplete
            companyList: companyList, autoCompanyInfo: autoCompanyInfo, handleSetAutoComplete: handleSetAutoComplete, resetAutoCompanyInfo: resetAutoCompanyInfo, companyInfo: companyInfo, 
            //image
            fileRef: fileRef, cropedImage: cropedImage, onClickFileAdd: onClickFileAdd, onChangeFileSelected: onChangeFileSelected, 
            //action button
            onClickCompZoneAdminInsert: onClickCompZoneAdminInsert, 
            //onClickCancel={onClickCancel}
            onClickSaveCompanyZone: onClickSaveCompanyZone }));
    });
    // 로컬 파일 URL을 통해 파일 객체 데이터 화
    function handleSetCropedImage(cropVal) {
        //clog("save croped file : " + JSON.stringify(cropVal));
        //var imgDataUrl = sigCanvas.toDataURL('image/png');
        var binaryData = atob(cropVal.url.split(',')[1]);
        var array = [];
        for (var i = 0; i < binaryData.length; i++) {
            array.push(binaryData.charCodeAt(i));
        }
        var file = new File([new Uint8Array(array)], cropVal.name, { type: 'image/png' });
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            fileId: "INS_0",
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        setCropedImage(fileVal);
    }
    ;
    // 파일 선택창 업로드
    function onClickFileAdd(e) {
        clog("onClickFileAdd : " + "");
        fileRef.current.value = "";
        fileRef.current.setAttribute("data-pop", "pop-imgcrop"); // data-pop 사라지는 듯....
        fileRef.current.click();
    }
    // 파일 선택창에서 파일 선택시, 처리 기능
    function onChangeFileSelected(e) {
        clog("save attach file : " + JSON.stringify(e.target.files[0]));
        const files = e.target.files;
        const formData = new FormData();
        formData.append("files", files[0]);
        var fileVal = {
            fileId: "INS_0",
            name: files[0].name,
            url: URL.createObjectURL(files[0]),
            type: "INS",
            fileForm: formData,
        };
        setSelectedFiles(fileVal);
        // pop-up 오픈
        CUTIL.jsopen_Popup(e);
    }
    ;
    function onClickSaveCompanyZone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone`,
                appQuery: {
                    "companyId": companyInfo.companyId,
                    "zoneName": zoneInfo.zoneName,
                    "address": zoneInfo.address,
                    "memo": zoneInfo.memo
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE CREATE : " + JSON.stringify(data.body));
                    if (cropedImage) {
                        saveAttachFiles(data.body.zoneId, cropedImage.fileForm);
                    }
                    setParentCurTree("ZONE", Object.assign(Object.assign({}, curTree), { company: { "companyId": companyInfo.companyId, "companyName": companyInfo.companyName }, zone: { "zoneId": data.body.zoneId, "zoneName": data.body.zoneName } }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    function saveAttachFiles(zoneId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone/images?zoneId=${zoneId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE CREATE : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", ref: mobileRef },
            React.createElement("h2", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"),
            React.createElement("ul", { className: "tab__small" },
                React.createElement("li", { className: "on" },
                    React.createElement("a", { href: "#", className: "icon-pen" }, "\uC0AC\uC5C5\uC7A5")),
                React.createElement("li", null,
                    React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickCompZoneAdminInsert(e) }, "\uD68C\uC0AC/\uC0AC\uC5C5\uC7A5"))),
            React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement(AutoComplete, { workList: companyList, autoInfo: autoCompanyInfo, setAutoInfo: handleSetAutoComplete, resetAutoInfo: resetAutoCompanyInfo, errorList: errorList, errorField: "companyId" })),
                            React.createElement("p", { className: "txt-info ml-24 mt-10" }, "* e-Health Portal \uC5D0 \uB4F1\uB85D\uB41C \uD68C\uC0AC\uB9CC \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4. \uBAA9\uB85D\uC5D0 \uC5C6\uB294 \uACBD\uC6B0 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uC8FC\uC138\uC694.")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp5", value: companyInfo.url, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp6", value: companyInfo.businessNo, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uB300\uD45C \uAD00\uB9AC\uC790"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", value: companyInfo.administrator, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5C5\uC885/\uC5C5\uD0DC"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", value: companyInfo.classification, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", value: companyInfo.accountManager, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9 Tel"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", value: companyInfo.accMngrTelephone, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "I/F Info"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", value: companyInfo.interfaceInfo, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.memo, disabled: true }, companyInfo.memo))))),
                React.createElement("div", { className: "content__info" },
                    React.createElement("div", { className: "column" },
                        React.createElement("h3", null, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uC785\uB825"),
                        React.createElement("div", { className: "flex-row" },
                            React.createElement("div", { className: "img_workplace" },
                                React.createElement("div", { className: "btn-imgadd" },
                                    React.createElement("label", { onClick: (e) => onClickFileAdd(e) },
                                        React.createElement("span", { className: "hide" }, "\uC0AC\uC9C4\uCCA8\uBD80")),
                                    React.createElement("input", { type: "file", id: "img", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => onChangeFileSelected(e) })),
                                React.createElement("div", { id: "image_preview" }, (cropedImage)
                                    ? React.createElement("img", { src: cropedImage.url, alt: cropedImage.name })
                                    : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" }))),
                            React.createElement("ul", { className: "form__input ml-40" },
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "text", id: "inp2", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "zoneName")).length > 0) ? "input-error" : "", value: zoneInfo.zoneName, onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { zoneName: e.target.value })) }),
                                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "zoneName")).map((err) => err.msg)))),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("input", { type: "text", id: "inp2", placeholder: "\uC9C1\uC811\uC785\uB825", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: zoneInfo.address, onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { address: e.target.value })) }),
                                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "address")).map((err) => err.msg)))),
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                    React.createElement("div", { className: "input__area" },
                                        React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: zoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetZoneInfoMemo), onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: e.target.value })) }),
                                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
                        React.createElement("div", { className: "btn__wrap center" },
                            React.createElement("button", { type: "button", className: "add__item" },
                                React.createElement("span", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                        React.createElement("div", { className: "btn__wrap" },
                            React.createElement("button", { type: "button", className: "js-open", "data-pop": "pop-workplace", onClick: (e) => onClickSaveCompanyZone(e) },
                                React.createElement("span", null, "\uCD94\uAC00 \uC694\uCCAD")))))))));
}
;
export default ZoneInsertAdmin;
function MobileZoneInsertAdmin(props) {
    const zoneInfo = props.zoneInfo;
    const setZoneInfo = props.setZoneInfo;
    const callbackSetZoneInfoMemo = props.callbackSetZoneInfoMemo;
    const errorList = props.errorList;
    //autocomplete
    const companyList = props.companyList;
    const autoCompanyInfo = props.autoCompanyInfo;
    const handleSetAutoComplete = props.handleSetAutoComplete;
    const resetAutoCompanyInfo = props.resetAutoCompanyInfo;
    const companyInfo = props.companyInfo;
    //new image
    const fileRef = props.fileRef;
    const cropedImage = props.cropedImage;
    const onClickFileAdd = props.onClickFileAdd;
    const onChangeFileSelected = props.onChangeFileSelected;
    //
    const onClickCompZoneAdminInsert = props.onClickCompZoneAdminInsert;
    const onClickCancel = props.onClickCancel;
    const onClickSaveCompanyZone = props.onClickSaveCompanyZone;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right", id: "pop-area-right" },
                React.createElement("ul", { className: "tab__small" },
                    React.createElement("li", { className: "on" },
                        React.createElement("a", { href: "#", className: "icon-pen" }, "\uC0AC\uC5C5\uC7A5")),
                    React.createElement("li", null,
                        React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickCompZoneAdminInsert(e) }, "\uD68C\uC0AC/\uC0AC\uC5C5\uC7A5"))),
                React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
                    React.createElement("div", { className: "content__info" },
                        React.createElement("h3", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                        React.createElement("ul", { className: "form__input" },
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit star" }, "\uD68C\uC0AC \uBA85"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement(AutoComplete, { workList: companyList, autoInfo: autoCompanyInfo, setAutoInfo: handleSetAutoComplete, resetAutoInfo: resetAutoCompanyInfo, errorList: errorList, errorField: "companyId" })),
                                React.createElement("p", { className: "txt-info ml-24 mt-10" }, "* e-Health Portal \uC5D0 \uB4F1\uB85D\uB41C \uD68C\uC0AC\uB9CC \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4. \uBAA9\uB85D\uC5D0 \uC5C6\uB294 \uACBD\uC6B0 \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758\uC8FC\uC138\uC694.")),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "inp5", value: companyInfo.url, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", id: "inp6", value: companyInfo.businessNo, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uB300\uD45C \uAD00\uB9AC\uC790"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", value: companyInfo.administrator, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC5C5\uC885/\uC5C5\uD0DC"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", value: companyInfo.classification, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", value: companyInfo.accountManager, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9 Tel"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", value: companyInfo.accMngrTelephone, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "I/F Info"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { type: "text", value: companyInfo.interfaceInfo, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.memo, disabled: true }, companyInfo.memo))))),
                    React.createElement("div", { className: "content__info" },
                        React.createElement("div", { className: "column" },
                            React.createElement("h3", null, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uC785\uB825"),
                            React.createElement("div", { className: "flex-row" },
                                React.createElement("div", { className: "img_workplace" },
                                    React.createElement("div", { className: "btn-imgadd" },
                                        React.createElement("label", { onClick: (e) => onClickFileAdd(e) },
                                            React.createElement("span", { className: "hide" }, "\uC0AC\uC9C4\uCCA8\uBD80")),
                                        React.createElement("input", { type: "file", id: "img", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => onChangeFileSelected(e) })),
                                    React.createElement("div", { id: "image_preview" }, (cropedImage)
                                        ? React.createElement("img", { src: cropedImage.url, alt: cropedImage.name })
                                        : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" }))),
                                React.createElement("ul", { className: "form__input ml-40" },
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                        React.createElement("div", { className: "input__area" },
                                            React.createElement("input", { type: "text", id: "inp2", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "zoneName")).length > 0) ? "input-error" : "", value: zoneInfo.zoneName, onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { zoneName: e.target.value })) }),
                                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "zoneName")).map((err) => err.msg)))),
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                                        React.createElement("div", { className: "input__area" },
                                            React.createElement("input", { type: "text", id: "inp2", placeholder: "\uC9C1\uC811\uC785\uB825", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: zoneInfo.address, onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { address: e.target.value })) }),
                                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "address")).map((err) => err.msg)))),
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                        React.createElement("div", { className: "input__area" },
                                            React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: zoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetZoneInfoMemo), onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: e.target.value })) }),
                                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
                            React.createElement("div", { className: "btn__wrap center" },
                                React.createElement("button", { type: "button", className: "add__item" },
                                    React.createElement("span", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                            React.createElement("div", { className: "btn__wrap" },
                                React.createElement("button", { type: "button" },
                                    React.createElement("span", null, "\uCD94\uAC00 \uC694\uCCAD"))))),
                    React.createElement("div", { className: "btn__wrap center" },
                        React.createElement("button", { type: "button", className: "bg-gray btn-close js-close", 
                            //onClick={(e)=>onClickCancel(e)}
                            onClick: (e) => CUTIL.jsclose_Popup('pop-area-right') },
                            React.createElement("span", null, "\uCDE8\uC18C")),
                        React.createElement("button", { type: "button", onClick: (e) => onClickSaveCompanyZone(e) },
                            React.createElement("span", null, "\uC800\uC7A5"))))))));
}
